import RoboticArm from './RoboticArm';

export default function Hero() {
  return (
    <section className="pt-40 pb-28 px-6 max-w-6xl mx-auto flex items-center gap-12">
      <div className="max-w-2xl flex-shrink-0">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-800 leading-tight tracking-tight text-brand-text mb-6">
          We engineer the systems<br />
          behind <span className="text-brand-blue">tomorrow.</span>
        </h1>
        <p className="text-lg text-brand-text/60 max-w-xl mb-10 leading-relaxed">
          Robotics consulting, physical AI expertise, and international technical advisory for organizations solving real-world engineering challenges.
        </p>
        <div className="flex flex-wrap items-center gap-4">
          <a href="#contact" className="inline-block bg-brand-blue text-white text-sm font-medium px-6 py-3 hover:bg-blue-700 transition-colors">
            Start a conversation
          </a>
          <a href="#services" className="text-sm font-medium text-brand-text/70 hover:text-brand-blue transition-colors">
            View our capabilities →
          </a>
        </div>
      </div>
      <RoboticArm />
    </section>
  );
}
